export default "__VITE_ASSET__CPbENo2I__"